import type { JSX } from 'react';

import type { Replacements, TranslationKeyArg } from '@change-corgi/core/i18n';

import { useI18n } from '../misc';

type Props = Readonly<{
	value: TranslationKeyArg;
	count: number;
	replacements?: Replacements;
}>;

export function TranslatePlural({ value, count, replacements }: Props): JSX.Element {
	const { translatePlural } = useI18n();

	return <>{translatePlural(value, count, replacements)}</>;
}
